import { createRef, useState } from 'react'

import { ReactComponent as Icon } from '@/assets/images/icons/icon-plus.svg'

import { faqData } from '@/components/Faq/faqData'

import styles from './Faq.module.scss'

function Section({ data, onClick, isActive = false }) {
  const sectionRef = createRef()

  const handleClickOpenSection = (id) => {
    onClick(id)
  }

  return (
    <div className={`${styles.section} ${isActive ? styles.sectionActive : ''}`} ref={sectionRef}>
      <div className={styles.sectionTop} onClick={() => handleClickOpenSection(data.id)}>
        <p className={styles.sectionName}>{data.sectionName}</p>
        <Icon className={styles.icon} />
      </div>

      {isActive && (
        <div className={styles.questions}>
          {data.items.map((item) => (
            <div key={item.id}>
              <p className={styles.question}>{item.question}</p>
              <div className={styles.answer}>{item.answer}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

function Faq() {
  const [activeSection, setActiveSection] = useState(1)

  const handleClickSection = (id) => {
    if (id === activeSection) {
      setActiveSection(0)
    } else {
      setActiveSection(id)
    }
  }

  return (
    <section className={styles.faq} id="faq">
      <div className={styles.inner}>
        <h2 className={styles.title}>Частые вопросы</h2>

        <div className={styles.sections}>
          {faqData.map((item) => (
            <Section data={item} key={item.id} isActive={activeSection === item.id} onClick={handleClickSection} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Faq
